import Service from '@ember/service';

/*
 * This service is used to manage the state of nested rows for a single table. The service needs to be extended
 * for each usage, to separate the state of different tables. See item-list-expansion for an example.
 */
// eslint-disable-next-line ember/no-classic-classes
export default Service.extend({
  init(...args) {
    this._super(...args);
    if (!this.expandedRows) {
      this.set('expandedRows', []);
    }
    if (!this.collapsedRows) {
      this.set('collapsedRows', []);
    }
  },
  allExpanded: false,
  allCollapsed: false,
  expandAll() {
    this.setProperties({
      allExpanded: true,
      allCollapsed: false,
      collapsedRows: []
    });
  },
  collapseAll() {
    this.setProperties({
      allExpanded: false,
      allCollapsed: true,
      expandedRows: []
    });
  },
  expandRow(rowId) {
    this.expandedRows.addObject(rowId);
    this.collapsedRows.removeObject(rowId);
  },
  collapseRow(rowId) {
    this.expandedRows.removeObject(rowId);
    this.collapsedRows.addObject(rowId);
  },
  rowIsExpanded(rowId) {
    return this.expandedRows.includes(rowId);
  },
  rowIsCollapsed(rowId) {
    return this.collapsedRows.includes(rowId);
  },
  getRowState(rowId, isCollapsedByDefault = false) {
    let isCollapsed = isCollapsedByDefault;
    if (this.rowIsCollapsed(rowId)) {
      isCollapsed = true;
    } else if (this.rowIsExpanded(rowId)) {
      isCollapsed = false;
    } else if (this.allCollapsed) {
      isCollapsed = true;
    } else if (this.allExpanded) {
      isCollapsed = false;
    }
    return isCollapsed;
  },
  clearCollapsed() {
    this.setProperties({
      allCollapsed: false,
      collapsedRows: []
    });
  }
});